import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';

// extend the ComponentDefinition type with the additional fields for the component
interface CheckBoxComponentDefinition extends ComponentDefinition {}
@Component({
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBoxComponent extends AbstractComponent<CheckBoxComponentDefinition> {

  @Input() floatLabel: any;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }

  initializeFieldValue() {
    this.fieldValue = this.document[this.fieldName] as boolean;
  }
  onFieldValueChanged(fieldValue) {
    if (this.formControl) {
      this.formControl.patchValue(this.checkBool(fieldValue), {emitEvent: false, onlySelf: true});
      this.detectChanges();
    }
  }

  checkBool(fieldValue) {
    const isBooleanValue = typeof fieldValue === 'boolean' ||
      (typeof fieldValue === 'object' &&
        fieldValue !== null            &&
        typeof fieldValue.valueOf() === 'boolean');
    if(isBooleanValue){
      return fieldValue;
    }else{
      // Return false if fieldValue is [undefined or null or any non-boolean values];
      return (/true/).test(fieldValue);
    }
  }

  showToolTip(tooltip: MatTooltip, container: HTMLDivElement, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= container.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
